import i18next from 'i18next'

export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 octets'
  const k = 1024
  const sizes = ['octets', 'Ko', 'Mo', 'Go']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`
}

export const extractEmailUsername = (email: string): string => {
  return email.split('@')[0]
}

export const formatDateTime = (dateString: string): string => {
  const locale = i18next.language || 'fr'
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC'
  }).format(new Date(dateString))
}

export const formatFullDate = (dateString: string, locale: string = 'fr'): string => {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(dateString))
}